/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_FullscreenInputs */

const en_gc_editor_fullscreen = /** @type {(inputs: Gc_Editor_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full screen`)
};

const zh_gc_editor_fullscreen = /** @type {(inputs: Gc_Editor_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全屏`)
};

/**
* | output |
* | --- |
* | "Full screen" |
*
* @param {Gc_Editor_FullscreenInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_fullscreen = /** @type {((inputs?: Gc_Editor_FullscreenInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_FullscreenInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_fullscreen(inputs)
	return zh_gc_editor_fullscreen(inputs)
});
export { gc_editor_fullscreen as "gc.editor.fullscreen" }